import Modal from '@components/Modal'
import { DEFAULT_CURRENCY } from '@/constants/currencies'
import { backgroundOrange } from '@/theme/colors'
import { useCreateTrip } from '@hooks/useCreateTrip'
import { ButtonComponent, ButtonGroupComponent } from '@pages/Itinerary/AddEventModal/FormComponents'
import React, { useState } from 'react'
import { toast } from 'react-hot-toast'
import TripForm from './TripForm'

interface CreateTripModalProps {
	isOpen: boolean
	onClose: () => void
}

const CreateTripModal: React.FC<CreateTripModalProps> = ({ isOpen, onClose }) => {
	const [name, setName] = useState('')
	const [currencyCode, setCurrencyCode] = useState(DEFAULT_CURRENCY.code)
	const createTrip = useCreateTrip()

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		if (!name.trim()) {
			return
		}

		try {
			await createTrip.mutateAsync({
				name: name.trim(),
				defaultCurrencyCode: currencyCode,
			})
			toast.success('Trip created successfully!')
			setName('')
			setCurrencyCode(DEFAULT_CURRENCY.code)
			onClose()
		} catch (error) {
			toast.error('Failed to create trip. Please try again.')
			console.error('Error creating trip:', error)
		}
	}

	const handleCancel = () => {
		setName('')
		setCurrencyCode(DEFAULT_CURRENCY.code)
		onClose()
	}

	const handleNameChange = (newName: string) => {
		setName(newName)
	}

	const handleCurrencyChange = (newCurrencyCode: string) => {
		setCurrencyCode(newCurrencyCode)
	}

	const formId = 'create-trip-form'

	return (
		<Modal
			isOpen={isOpen}
			onClose={handleCancel}
			title="New Trip"
			closeOnBackdropClick={false}
			backgroundColor={backgroundOrange}
			footer={
				<ButtonGroupComponent>
					<ButtonComponent type="button" variant="secondary" onClick={handleCancel}>
						Cancel
					</ButtonComponent>
					<ButtonComponent type="submit" form={formId} variant="primary" disabled={!name.trim() || createTrip.isPending}>
						Create Trip
					</ButtonComponent>
				</ButtonGroupComponent>
			}
		>
			<TripForm
				formId={formId}
				name={name}
				currencyCode={currencyCode}
				onNameChange={handleNameChange}
				onCurrencyChange={handleCurrencyChange}
				onSubmit={handleSubmit}
			/>
		</Modal>
	)
}

export default CreateTripModal

